import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail } from 'lucide-react';
import SubstackBanner from './SubstackBanner';
import { PushButton } from './PushButton';

export default function Footer() {
  return (
    <footer className="bg-stilo-ink text-stilo-bg mt-32" data-testid="site-footer">
      <SubstackBanner />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <img src="/brand/studio-stilo-monogram.png" alt="Studio Stilo" className="h-14 w-14 mb-8 opacity-95" />
          <h3 className="font-serif text-4xl leading-tight font-light">Diseñamos espacios que se sienten como tú.</h3>
          <p className="mt-4 text-stilo-stone/80 max-w-md">Studio Stilo es un estudio de diseño de interiores y home staging con tienda propia, Stilo Decor.</p>
          <PushButton dark className="mt-6" label="Avisos en el móvil" testid="footer-push-toggle" />
        </div>
        <div className="md:col-span-2">
          <p className="overline !text-stilo-stone">Estudio</p>
          <ul className="mt-4 space-y-2 text-stilo-stone/90">
            <li><Link to="/asesorias" className="hover:text-stilo-bg">Asesorías</Link></li>
            <li><Link to="/conversaciones" className="hover:text-stilo-bg">Conversaciones</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="overline !text-stilo-stone">Tienda</p>
          <ul className="mt-4 space-y-2 text-stilo-stone/90">
            <li><a href="https://www.stilodecor.com" target="_blank" rel="noreferrer" className="hover:text-stilo-bg">Stilo Decor</a></li>
            <li><Link to="/mis-asesorias" className="hover:text-stilo-bg">Mis asesorías</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="overline !text-stilo-stone">Contacto</p>
          <a href="mailto:claraperez@studiostiloid.com" data-testid="footer-email" className="mt-4 flex items-center gap-2 text-stilo-stone/90 hover:text-stilo-bg"><Mail className="w-4 h-4" strokeWidth={1.5} /> claraperez@studiostiloid.com</a>
          <a href="https://www.instagram.com/studiostilo_id/" target="_blank" rel="noreferrer" data-testid="footer-instagram-studio" className="mt-2 flex items-center gap-2 text-stilo-stone/90 hover:text-stilo-bg"><Instagram className="w-4 h-4" strokeWidth={1.5} /> @studiostilo_id</a>
          <a href="https://www.instagram.com/stilodecor_bs/" target="_blank" rel="noreferrer" data-testid="footer-instagram-decor" className="mt-2 flex items-center gap-2 text-stilo-stone/90 hover:text-stilo-bg"><Instagram className="w-4 h-4" strokeWidth={1.5} /> @stilodecor_bs</a>
        </div>
      </div>
      <div className="border-t border-stilo-stone/15">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row justify-between text-xs text-stilo-stone/60">
          <span>© 2026 Studio Stilo. Todos los derechos reservados.</span>
          <span>Hecho con cuidado en España</span>
        </div>
      </div>
    </footer>
  );
}
